import { render } from "./smallArrow.vue?vue&type=template&id=22dc4dde"
import script from "./smallArrow.vue?vue&type=script&lang=js"
export * from "./smallArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__